import { Component, OnInit } from '@angular/core';
import {Router} from '@angular/router';
import {DomSanitizer} from '@angular/platform-browser';
import { environment } from '@env/environment';

@Component({
  selector: 'app-shell',
  templateUrl: './shell.component.html',
  styleUrls: ['./shell.component.scss']
})

export class ShellComponent implements OnInit {
    showChat = false;
    showChatButton = false;
    urlIframe: any = '';

    constructor(private route: Router, private santize: DomSanitizer) {
      if (this.route.url.indexOf('shopping') === -1) {
        this.showChatButton = true;
      }

      route.events.subscribe( (event) => {
        this.showChatButton = !!(this.route.url.indexOf('shopping') === -1
          || this.route.url.match(/shopping\/\w*\//gi));
      });
    }

    showChatFunc() {
      this.urlIframe = this.santize.bypassSecurityTrustResourceUrl(environment.chatbotUrl);
      this.showChat = true;
    }

    ngOnInit() { }
}



// WEBPACK FOOTER //
// d:/workspace/wynk_web_shoppings_3_prod/src/app/core/shell/shell.component.ts